import React, { useEffect, useState } from "react";
import NotesContainer from "../Notes/NotesContainer";
import {
  collection,
  query,
  where,
  orderBy,
  limit,
  onSnapshot,
} from "firebase/firestore";
import { db } from "../../firebase";
import { CircularProgress } from "@mui/material";
import { incrementDailyReads } from "../../logsComponents/incrementDailyReads";

function NonTherapyNoteContainerAll(props) {
  const [notes, setNotes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const notesRef = collection(db, "notes");
    const q = query(
      notesRef,
      where("noteType", "==", "supportStaffNote"),
      orderBy("effectiveDateTime", "desc"),
      limit(50)
    );

    const unsubscribe = onSnapshot(q, async (querySnapshot) => {
      const notesData = [];
      querySnapshot.forEach((doc) => {
        notesData.push({ id: doc.id, ...doc.data() });
      });
      setLoading(false);
      setNotes(notesData);
      try { incrementDailyReads("notes_support", querySnapshot.size); } catch {}
    });

    return () => {
      unsubscribe();
    };
  }, []);

  return (
    <div className="notes-container-global">
      {loading ? (
        <div style={{ textAlign: "center" }}>
          <CircularProgress />
          <p>Loading, please wait...</p>
        </div>
      ) : (
        notes.map((note, index) => {
          const dateOptions = {
            day: "numeric",
            month: "short",
            year: "numeric",
          };

          const dateOptions2 = {
            day: "numeric",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
          };

          const timeOptions = {
            hour: "2-digit",
            minute: "2-digit",
          };

          const formattedTimestamp = note.createdAt
            ? new Intl.DateTimeFormat("en-EN", dateOptions2).format(
                note.createdAt.toDate()
              )
            : "";

          const formattedLastModification = note.updateAt
            ? new Intl.DateTimeFormat("en-EN", dateOptions2).format(
                note.updateAt.toDate()
              )
            : "";

          const formattedDate = note.effectiveDateTime
            ? new Intl.DateTimeFormat("en-EN", dateOptions).format(
                note.effectiveDateTime.toDate()
              )
            : "";

          const formattedTime = note.effectiveDateTime
            ? new Intl.DateTimeFormat("en-EN", timeOptions).format(
                note.effectiveDateTime.toDate()
              )
            : "";

          return (
            <div key={note.id || index} style={{ paddingBottom: "15px" }}>
              <NotesContainer
                key={note.id}
                noteContent={note.noteContent}
                effectiveDate={note.effectiveDateTime}
                noteDate={formattedDate}
                noteTime={formattedTime}
                doneBy={note.doneBy}
                timeStamp={formattedTimestamp}
                lastModification={formattedLastModification}
                clientPic={note.clientProfilePicture}
                clientFirstName={note.clientFirstName}
                clientLastName={note.clientLastName}
                noteId={note.id}
                {...note}
              />
            </div>
          );
        })
      )}
    </div>
  );
}

export default NonTherapyNoteContainerAll;
